import HeaderWrapperDesktop from "../header-wrapper-desktop"
import Flex from "../../../../components/flex"
import { reportStore } from "@/routes/apt/[apt_code]/report/report-store"
import { useParams, useSearchParams } from "react-router-dom"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"
import AptHeaderContent from "../apt-header-content"
import DateInput from "../../../../components/date-input"
import SearchButton from "../../../../components/buttons/search-button"
import { langStore } from "@/stores/lang-store"
import { useState } from "react"
import dayjs from "dayjs"
import { toast } from "sonner"
import { headerBundle } from "./report-header-const"

const ReportHeaderDesktop = ({ position = "sticky" }) => {
  const { lang } = langStore()
  const { apt } = useParams()

  const [searchParams, setSearchParams] = useSearchParams()
  const resource = searchParams.get("resource")
  const startDate = searchParams.get("start_date") ?? ""
  const endDate = searchParams.get("end_date") ?? ""

  const { ended_at } = aptSearchStore((s) => s.pickApt)
  const { apiGetReport } = reportStore()

  const [startDateView, setStartDateView] = useState("")
  const [endDateView, setEndDateView] = useState("")

  const search = async () => {
    const start_date = startDateView ? startDateView : startDate
    const end_date = endDateView ? endDateView : endDate
    if (dayjs(start_date).isAfter(dayjs(end_date))) {
      toast.info(headerBundle.startDateError[lang])
      return
    }

    setSearchParams((prev) => {
      const next = new URLSearchParams(prev)

      next.set("start_date", start_date)
      next.set("end_date", end_date)

      return next
    })

    await apiGetReport({ apt, start_date, end_date, resource })
  }

  return (
    <HeaderWrapperDesktop position={position} useRight={false}>
      <AptHeaderContent label={headerBundle.caption[lang]}>
        <Flex className="items-center ml-auto" gap={4}>
          <DateInput
            value={startDateView || startDate}
            max={ended_at}
            onChange={(e) => setStartDateView(e.target.value)}
          />
          <span className="font-bold px-0.5 text-sm text-gray-300">~</span>
          <DateInput
            value={endDateView || endDate}
            max={ended_at}
            onChange={(e) => setEndDateView(e.target.value)}
          />
          <SearchButton onClick={search} lang={lang} />
        </Flex>
      </AptHeaderContent>
    </HeaderWrapperDesktop>
  )
}

export default ReportHeaderDesktop
